import script from "./DisplaysGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplaysGuide.vue?vue&type=script&setup=true&lang=js"

import "./DisplaysGuide.vue?vue&type=style&index=0&id=2899a7c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2899a7c0"]])

export default __exports__